module.exports = __webpack_public_path__ + "static/media/RU.7d5a328d.svg";